import { useEffect, useMemo, useRef, useState } from "react";
import { useCrdtUtils } from "./CrdtElement";
export function useCrdtEventCallback(action) {
    var crdtElement = useCrdtUtils();
    var _a = useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef(null);
    var memoizedAction = useMemo(function () { return action; }, [action]);
    useEffect(function () {
        var _a;
        if (!(crdtElement === null || crdtElement === void 0 ? void 0 : crdtElement.on))
            return;
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = (_a = crdtElement === null || crdtElement === void 0 ? void 0 : crdtElement.on(memoizedAction)) === null || _a === void 0 ? void 0 : _a.subscribe(function (data) {
            setData(data);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [crdtElement === null || crdtElement === void 0 ? void 0 : crdtElement.on, memoizedAction]);
    return data;
}
